import {  useState } from 'react';
import { createSearchParams, useNavigate } from 'react-router-dom';
import useAppState from '../../../context/AppContext';
import MgpMessage from '../../../elements/MgpMessage/MgpMessage';
import RecapBeneficiaryFormComponent from '../../../components/recap/RecapBeneficiaryFormComponent';
import ConfirmModal from '../../../modals/common/ConfirmModal';
import LoaderModal from '../../../modals/common/LoaderModal';
import StickButtonsBloc from '../../common/StickButtonsBloc';
import {  APP_RETIREMENT_URLS } from '../../../const/AppConst';
import REInfoPersoRecapTemplate from '../../../components/retirement/info-perso/REInfoPersoRecapTemplate';
import { AxiosError } from 'axios';
import { IApiErrors, IUpdatedProposition } from '../../../context/model';
import { disabledRESteps, isPropositionInDraft, isPropositionInLock } from '../../../utils/dataUtils';
import { lockRetirementProposition } from '../../../services/CustomerApiService';


export default function RERecapRetirementBloc() {
  const navigate = useNavigate();

  const {
    state: {  proposition, updatedProposition, jwtToken , additionalData},
    dispatch,
  } = useAppState();  
  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [loading, setLoading] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false)

  const showConfirmationModal = () => {
    setIsShowModal(true);
  }
  const closeModal = () => {
    setIsShowModal(false)
  }
  const onNextAction = async () => {
    closeModal();
    setErrorMsg(null);
    try {
          if(updatedProposition && proposition) {
            let newProposition;
            if (isPropositionInDraft(proposition)) {
              setLoading(true);
              const newUpdatedPropo: IUpdatedProposition = {
                ...updatedProposition, 
                iban: updatedProposition?.iban.replaceAll(/\s/g,''),
                birthName: updatedProposition?.birthName === "" ? "EMPTY_STRING_PLACEHOLDER" : updatedProposition?.birthName,
                oldCompetitor: {
                  ...updatedProposition.oldCompetitor, 
                  // this makes sure old competitor NAME is displayed (or name or othername)
                  name: updatedProposition.oldCompetitor?.name?.length === 0 
                        ? updatedProposition.oldCompetitor?.otherName
                        : updatedProposition.oldCompetitor?.name
                }
              }
              const payload = await lockRetirementProposition(
                jwtToken!.accessToken, 
                proposition.propositionId, 
                newUpdatedPropo);
              newProposition = payload.data;
              const steps = disabledRESteps();
              dispatch({type: "UPDATE_STEPS", steps: steps});
            }                 
               
            let url=APP_RETIREMENT_URLS.infoSignatureDocumentPage;
    
            dispatch({
              type: 'NEXT_INFO_STEP', 
              path: url, 
              proposition: newProposition});
              
            navigate({
            pathname: url,
            search: createSearchParams({
                id: proposition.propositionId
            }).toString(),
            }, {replace: true});
          } 
    
        } catch (error) {
          const err = error as AxiosError;
          console.log(err);
          setLoading(false);
          if(err.response && err.response.status == 400) {
            const errorData = err.response?.data as IApiErrors;
            setErrorMsg("Erreur: " + errorData.message);
          } else {
            setErrorMsg("Une erreur technique est survenue ");
          }
        }
  }

  const onNextLockedPropositionAction = () => {
    let url=APP_RETIREMENT_URLS.infoSignatureDocumentPage;
    
    dispatch({type: 'NEXT_INFO_STEP', path: url});
    navigate({
    pathname: url,
    search: createSearchParams({
        id: proposition!.propositionId
    }).toString(),
    }, {replace: true});
  }

  const onPreviousAction = () => {
     if(isPropositionInLock(proposition!) ) {
          return;
        }
    const url = (additionalData?.hasChild || additionalData?.hasPartner) 
      ? APP_RETIREMENT_URLS.infoFamilyDocPage 
      : APP_RETIREMENT_URLS.infoLastEmployeeDocPage;

    dispatch({type: 'BACK_INFO_STEP', path: url});
    navigate({
        pathname: url,
        search: `?id=${proposition!.propositionId}`,
    });   
   
  }

    return (
      
      <div id='recap-bloc'>
        <div>
          {errorMsg 
          && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
        </div>
     
        <div className='m-lg-desktop'>
          <REInfoPersoRecapTemplate
            modifyIdentityUrl={APP_RETIREMENT_URLS.infoIdentityPage}
            modifyContactUrl= {APP_RETIREMENT_URLS.infoContactPage}
            modifyHealthInfoUrl={APP_RETIREMENT_URLS.infoAttestationROPage}
            modifyAddressUrl= {APP_RETIREMENT_URLS.infoAddressPage}
            modifyInfoBankUrl={APP_RETIREMENT_URLS.infoBankPage}
          />
        </div>  
        <RecapBeneficiaryFormComponent 
            modifyUrl={APP_RETIREMENT_URLS.infoBeneficiaryPage}/>

        {
          isPropositionInDraft(proposition!) ? 
          <StickButtonsBloc 
              disabledPreviousButton={false} 
              showNextButton={true}
              showPreviousButton={true} 
              previousAction={onPreviousAction} 
              nextAction={showConfirmationModal} 
              nextButtonName="Confirmer"/>
          :
          <StickButtonsBloc 
              disabledPreviousButton={false}
              showNextButton={true}
              showPreviousButton={false} 
              previousAction={onPreviousAction} 
              nextAction={onNextLockedPropositionAction}/>
        }
        
        
        {loading 
        && <LoaderModal hasMessage={true}/>}
        <ConfirmModal 
            isOpen={isShowModal}
            onConfirmAction={onNextAction}
            onCloseModal={closeModal} 
            text={<p className="ta-center bleu fz-lg fw-bold">
          Nous vous invitons à vérifier l'exactitude des informations saisies. 
          Passé cette étape, il ne sera plus possible de les modifier.
          </p>} />
      </div>
    )
}